import { ManageRewards } from './ManageRewards'

export * from "./hooks/useRewardsForm"

export default ManageRewards;